import StatsDashboardPage from './StatsDashboardPage';
export default StatsDashboardPage;
